import { buildReducer } from '../../../shared';
import { personaEditClickedAction } from '../../../hub';
import type { EditContactOptionsState } from '../../state/view/editContactOptionsState';

const defaultState = { focusPropertyUri: null };

export default buildReducer<EditContactOptionsState>()
    .handle(personaEditClickedAction, (state, action) => action.payload.options || defaultState)
    .done(defaultState);
export type { Action } from '../../../shared';
